import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import immutable from 'object-path-immutable';
import numeral from 'numeral';
import * as SalesActions from '../redux/SalesActions';

const porcents = {
  efectivo: 0,
  cheque: 0,
  transferencia: 0,
  pv: 3,
  tc: 3,
  td: 2,
};

class commissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        comision: '',
      },
    };
  }

  calculateComissions = (nextProps) => {
    let { Sales } = nextProps;

    var sumFunction = function (a, b) {
      return a - 0 + (b - 0);
    };

    var UtilityWithoutPayForm =
      Sales.balance.totalPrice - 0 - (Sales.balance.totalBuyPrice - 0);

    let totalPayFormValueTotal = 0;

    Sales.receipts.map((receipt) => {
      if (!receipt.cancel) {
        if (
          receipt &&
          receipt.conceptsArray &&
          receipt.conceptsArray.length > 0
        ) {
          receipt.conceptsArray.map((item) => {
            totalPayFormValueTotal += item.amount * (item.percent / 100);
          });
        } else {
          totalPayFormValueTotal =
            totalPayFormValueTotal + receipt.amount * (receipt.percent / 100);
        }
      }
    });
    var totalPayFormValue = totalPayFormValueTotal;
    var utility = UtilityWithoutPayForm - totalPayFormValue;

    var commissions = utility * (Sales.balance.commissionsPercent / 100);
    var netProfit = utility - commissions;

    if (Sales.balance.otherExpenses > 0) {
      netProfit = netProfit - Sales.balance.otherExpenses;
    }

    var newState = immutable.set(Sales, 'balance.utility', utility);
    newState = immutable.set(newState, 'balance.commissions', commissions);
    newState = immutable.set(
      newState,
      'balance.totalPayFormValue',
      totalPayFormValue
    );
    newState = immutable.set(newState, 'balance.netProfit', netProfit);

    if (
      JSON.stringify(this.props.Sales.balance) !==
      JSON.stringify(newState.balance)
    )
      nextProps.dispatch(SalesActions.setState(newState));
  };

  componentWillMount() {
    this.calculateComissions(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.calculateComissions(nextProps);
  }

  onChange = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);

    this.setState({
      formData: newFormData,
    });
  };

  handledChangeTypePay = (value) => {
    var newState = immutable.set(
      this.props.Sales,
      'balance.payForm',
      value.value
    );
    newState = immutable.set(
      newState,
      'balance.totalPayForm',
      porcents[value.value]
    );

    this.props.dispatch(SalesActions.setState(newState));
  };

  render() {
    let { Sales } = this.props;
    const { formData } = this.state;

    return (
      <div>
        <div>
          <h6>Total Cliente</h6>
          <h4 style={{ marginTop: 5 }}>
            {numeral(Sales.balance.totalPrice).format('$0,0.00')}
          </h4>
          <Row>
            <Col md={6}>
              <h6>Total Operador</h6>
              <h4 style={{ marginTop: 5 }}>
                -{numeral(Sales.balance.totalBuyPrice).format('$0,0.00')}
              </h4>
            </Col>
            <Col md={6}>
              <h6>Pagado al operador</h6>
              <h4 style={{ marginTop: 5, display: 'flex' }}>
                {Number(Sales.balance.totalBuyPrice) ===
                Number(Sales.balance.totalOperatorPayed) ? (
                  <i
                    style={{
                      fontSize: 30,
                      color: 'green',
                    }}
                    className="fa fa-check-circle-o"
                    aria-hidden="true"
                  />
                ) : (
                  <i
                    style={{
                      fontSize: 30,
                      color: 'red',
                    }}
                    className="fa fa-times-circle-o"
                    aria-hidden="true"
                  />
                )}{' '}
                <div style={{ marginLeft: 10 }}>
                  {numeral(Sales.balance.totalOperatorPayed).format('$0,0.00')}
                </div>
              </h4>
            </Col>
          </Row>

          <h6>Forma de pago</h6>
          <Row style={{ marginBottom: 0 }}>
            <Col md={4}>
              <h4 style={{ marginTop: 0 }}>
                - {numeral(Sales.balance.totalPayFormValue).format('$0,0.00')}
              </h4>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <h6>Utilidad RSViajes</h6>
              <h4 style={{ marginTop: 5 }}>
                ={numeral(Sales.balance.utility).format('$0,0.00')}
              </h4>
            </Col>
          </Row>

          <h6>(-) Otros Gastos</h6>
          <Row>
            <Col md={6}>
              <input
                style={{ marginTop: 10, marginBottom: 10 }}
                type="number"
                className="form-control"
                value={Sales.balance.otherExpenses}
                onChange={(event) =>
                  this.props.dispatch(
                    SalesActions.onChange(
                      ['balance', 'otherExpenses'],
                      event.target.value
                    )
                  )
                }
              />
            </Col>
          </Row>

          <h6>Comisiones</h6>
          <Row>
            <Col md={3}>
              <h4 style={{ marginTop: 5 }}>
                -{numeral(Sales.balance.commissions).format('$0,0.00')}
              </h4>
            </Col>
            <Col md={4}>
              <input
                type="number"
                step="any"
                className="form-control"
                id="comision"
                value={Sales.balance.commissionsPercent}
                onChange={(event) =>
                  this.props.dispatch(
                    SalesActions.onChange(
                      ['balance', 'commissionsPercent'],
                      event.target.value
                    )
                  )
                }
              />
            </Col>
            <Col md={1}>%</Col>
          </Row>
          <h6>Utilidad Neta</h6>
          <h4 style={{ marginTop: 5 }}>
            <strong>
              ={numeral(Sales.balance.netProfit).format('$0,0.00')}
            </strong>
          </h4>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(commissions);



// WEBPACK FOOTER //
// ./src/views/Sales/cards/commissions.js